const Iframe = ({url}) => (
  <iframe
    src={url}
    width="100%"
    height="500"
    type="text/html"
    frameBorder="0"
    style={{ border: 0 }}
    title="iframe form"
  ></iframe>
);

export default Iframe;